/**
 * Constantes globales pour l'application frontend
 *
 * Ce fichier contient les constantes utilisées dans l'application frontend :
 * - Labels de prix pour les différents types de clients
 * - Identifiants pour les calculs de tarification
 *
 * Logique métier :
 * - Constantes pour la tarification des enfants
 * - Utilisées dans les calculs de prix et l'affichage
 */

/**
 * Label de prix pour les enfants de moins de 7 ans
 * Utilisé pour identifier et calculer les tarifs spéciaux enfants
 */
export const PRICE_LABEL_CHILD_UNDER_7 = "prix-enfant-7ans";